export default __webpack_public_path__ + "static/hack4change-final-white@3x-232d937619e5faac513db93c500a430d.png";